import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString } from "vue"

import { watch } from 'vue';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

// 定义重定向映射
const redirectMap: Record<string, string> = {
  '/programs/tetrapak-jp': 'https://www.terracycle.com/ja-JP/brigades/tetrapak-jp',
  '/programs/nisshinfire-jp': 'https://www.terracycle.com/ja-JP/brigades/nisshinfire',
  '/programs/tetrapak-jp-tcpoint': 'https://docs.google.com/forms/d/1qu5yYtF_DYu31bfD58hLe1E95mlVLOCESBKIHgWTrV4/viewform?edit_requested=true'
};

// 监听路由变化
watch(
  () => route.path,
  (newPath) => {
    // 只在非开发环境执行重定向
    if (process.env.VUE_APP_ENV !== 'development' && redirectMap[newPath]) {
      // 执行重定向
      window.location.href = redirectMap[newPath];
    } else if (process.env.VUE_APP_ENV === 'development' && redirectMap[newPath]) {
      // 开发环境下显示提示信息
      // eslint-disable-next-line no-console
      console.log(`[开发环境] 检测到重定向路径: ${newPath} -> ${redirectMap[newPath]}`);
    }
  },
  { immediate: true } // 立即执行一次，处理初始路由
);

return (_ctx: any,_cache: any) => {
  return _toDisplayString(null)
}
}

})